import { Typography } from '@mui/joy';

import { Level } from 'theme/enums';

import SubtitleWrapper from './SubtitleWrapper';
import TitleWrapper from './TitleWrapper';

interface IProps {
  text: string | JSX.Element;
  subtitle?: string | JSX.Element;
}

const Title = ({ text, subtitle }: IProps) => {
  return (
    <TitleWrapper>
      <Typography level={Level.H4}>{text}</Typography>

      {subtitle && <SubtitleWrapper>{subtitle}</SubtitleWrapper>}
    </TitleWrapper>
  );
};

export default Title;
